"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TrialsConfigCycleItem_vue_1 = __importDefault(require("./TrialsConfigCycleItem.vue"));
const CellTreatmentDetail_vue_1 = __importDefault(require("./CellTreatmentDetail.vue"));
const ModalDetailsProcess_vue_1 = __importDefault(require("./modals/ModalDetailsProcess.vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const ModalSamplesList_vue_1 = __importDefault(require("./modals/ModalSamplesList.vue"));
const AsyncResponse_1 = __importDefault(require("../Abstract/models/AsyncResponse"));
const Sample_1 = __importDefault(require("../Abstract/models/Sample"));
const Treatment_1 = __importDefault(require("../Abstract/models/Treatment"));
const TrialsConfigurationSamplesService_1 = __importDefault(require("../Abstract/services/TrialsConfigurationSamplesService"));
let DetailsLocationsContainer = class DetailsLocationsContainer extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.specificSamples = [];
        this.isDeployedModalDetailsProcess = false;
        this.isDeployedModalSamplesList = false;
        this.isDeployModalConfirm = false;
        this.isLoadingMarkSamples = false;
        this.setDateAsyncResponse = new AsyncResponse_1.default({});
        this.currentMissingSamples = -1;
        this.currentTimeOrder = -1;
        this.action = '';
        this.samplesService = new TrialsConfigurationSamplesService_1.default(this.params);
    }
    get activeSamples() {
        return this.action.length !== 0 && this.action == 'assign' ? this.samples : this.specificSamples;
    }
    dismissAllModals() {
        this.action = '';
        this.isDeployedModalSamplesList = false;
        this.isDeployedModalDetailsProcess = false;
    }
    onTreatmentCellClick(treatment) {
        this.currentMissingSamples = treatment.missingSamplesCurrentTime;
        this.currentTimeOrder = treatment.currentTime;
        this.currentTreatment = new Treatment_1.default(treatment);
        this.deployModalSamplesList();
        this.action = 'assign';
    }
    onTimeCycleClick(treatment, time) {
        this.currentTreatment = new Treatment_1.default(treatment);
        this.currentMissingSamples = treatment.times[time.order].samplesTotalThisTime - treatment.times[time.order].samplesAssignedForTime;
        this.currentTimeOrder = time.order;
        this.deployModalDetailsProcess();
    }
    deployAssignation() {
        this.deployModalSamplesList();
        this.action = 'assign';
    }
    async deployMarkListCodes(data) {
        const response = await this.samplesService.getAssignedSamples(data);
        this.specificSamples = response.data.map((s) => new Sample_1.default(s));
        this.dismissAllModals();
        this.deployModalSamplesList();
        this.action = 'mark';
    }
    backModalSamplesList() {
        this.dismissAllModals();
        this.deployModalDetailsProcess();
    }
    updateAssignatedSamples(payload) {
        this.$emit('updateAssignatedSamples', payload);
    }
    updateSentSamples(payload) {
        this.$emit('updateSentSamples', payload);
    }
    textUpperCase(text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
    collectAccent(time) {
        if (time.samplesAssignedForTime === time.samplesTotalThisTime ||
            time.samplesAssignedForTime > time.samplesTotalThisTime) {
            return 'success';
        }
        else if (time.samplesAssignedForTime === 0) {
            return 'gray';
        }
        else if (time.samplesAssignedForTime < time.samplesTotalThisTime) {
            return 'primary';
        }
        return 'gray';
    }
    collectPercent(time) {
        if (time.samplesAssignedForTime > time.samplesTotalThisTime ||
            (time.samplesAssignedForTime === time.samplesTotalThisTime &&
                time.samplesTotalThisTime > 0)) {
            return 100;
        }
        else {
            return (time.samplesAssignedForTime / time.samplesTotalThisTime) * 100;
        }
    }
    isLineCompleted(treatment) {
        let isCompleted = true;
        for (const time of treatment.times) {
            if (time.samplesAssignedForTime < time.samplesTotalThisTime) {
                isCompleted = false;
            }
        }
        return isCompleted;
    }
    isLineLeft(index) {
        if (index === 0)
            return false;
        return true;
    }
    isLineRight(index, treatment) {
        if (index === treatment.times.length - 1)
            return false;
        return true;
    }
    async markDetailInfo(data) {
        this.setDateAsyncResponse.loading = true;
        const response = await this.samplesService.setDateToSampleGroup(data);
        (response.data.status === 200) ?
            this.setDateAsyncResponse.success = true :
            this.setDateAsyncResponse.success = false;
        this.setDateAsyncResponse.feedback = response.data.messages;
        this.setDateAsyncResponse.loading = false;
    }
    resetSetDateAsyncResponse() {
        this.setDateAsyncResponse = new AsyncResponse_1.default({});
    }
    dismissModalDetailsProcess() {
        this.isDeployedModalDetailsProcess = false;
    }
    deployModalDetailsProcess() {
        this.dismissAllModals();
        this.isDeployedModalDetailsProcess = true;
    }
    deployModalSamplesList() {
        this.dismissAllModals();
        this.isDeployedModalSamplesList = true;
    }
    dismissModalSamplesList() {
        this.isDeployedModalSamplesList = false;
    }
    async deployListCodes(data) {
        const response = await this.samplesService.getAssignedSamples(data);
        this.specificSamples = response.data.map((s) => new Sample_1.default(s));
        this.dismissAllModals();
        this.action = '';
        this.deployModalSamplesList();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], DetailsLocationsContainer.prototype, "location", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], DetailsLocationsContainer.prototype, "isLoading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], DetailsLocationsContainer.prototype, "samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], DetailsLocationsContainer.prototype, "params", void 0);
DetailsLocationsContainer = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            ListIcon: bmk_ui_framework_1.ListIcon,
            TrialsConfigCycleItem: TrialsConfigCycleItem_vue_1.default,
            CircleProgress: bmk_ui_framework_1.CircleProgress,
            CellTreatmentDetail: CellTreatmentDetail_vue_1.default,
            ModalDetailsProcess: ModalDetailsProcess_vue_1.default,
            ModalSamplesList: ModalSamplesList_vue_1.default,
            ViewZero: bmk_ui_framework_1.ViewZero,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            Loading: bmk_ui_framework_1.Loading,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
        },
    })
], DetailsLocationsContainer);
exports.default = DetailsLocationsContainer;
